import React from 'react';
import {
    Link,
    NavLink,
    Redirect,
    NavLinkProps,
    LinkProps,
    RedirectProps,
} from 'react-router-dom';
import { parseQueryString, toQueryString } from '@/utils/url';
import { LocationDescriptorObject, Path } from 'history';
import { classnames } from '@/utils/html';

function addQuerySupport(to) {
    if (to != null && typeof to === 'object' && to.query) {
        const query = {
            ...parseQueryString(to.search),
            ...to.query,
        };

        to = {
            ...to,
            search: toQueryString(query),
        };
    }

    return to;
}

export type CustomLinkProps = LinkProps & {
    to: LocationDescriptorWithQuery
}


export const CustomLink:React.FC<CustomLinkProps> = React.forwardRef<HTMLAnchorElement, CustomLinkProps>(({ to, children, className, ...rest }, ref) => {
    return (
        <Link className={classnames(className, "internal")} to={addQuerySupport(to)} ref={ref} {...rest}>
            {children}
        </Link>
    );
});

export type CustomNavLinkProps = NavLinkProps & {
    to: LocationDescriptorWithQuery
}

export const CustomNavLink:React.FC<CustomNavLinkProps> = ({ to, children, activeClassName, className, ...rest }) => {
    return (
        <NavLink className={classnames(className, "internal")} to={addQuerySupport(to)} activeClassName={activeClassName || 'active'} {...rest}>
            {children}
        </NavLink>
    );
};

type LocationDescriptorWithQuery = Path | (LocationDescriptorObject & {
    query?: any
});

type RedirectPropsWithQuery = RedirectProps & {
    to: LocationDescriptorWithQuery
}


export const CustomRedirect:React.FC<RedirectPropsWithQuery> = ({ to, ...rest }) => <Redirect to={addQuerySupport(to)} {...rest} />;


// export const RedirectWithReturnUrl = withRouter(({ location, path }: RouteComponentProps<any> & { path: string }) => (
//     <CustomRedirect to={{ pathname: path, query: { returnUrl: location.pathname } }} />
// ));
